import { reactive } from 'vue';

// Simple global confirm bus state
const state = reactive({
  open: false,
  options: null,
  _resolve: null,
});

function normalize(options = {}) {
  return {
    title: options.title || 'Confirm',
    message: options.message || '',
    cancelText: options.cancelText || 'Cancel',
    confirmText: options.confirmText || 'OK',
    type: options.type || 'is-info',
    hasIcon: !!options.hasIcon,
  };
}

export function openConfirm(options = {}) {
  return new Promise((resolve) => {
    state.options = normalize(options);
    state._resolve = resolve;
    state.open = true;
  });
}

export function confirm() {
  try {
    if (typeof state._resolve === 'function') state._resolve(true);
  } finally {
    state.open = false;
    state.options = null;
    state._resolve = null;
  }
}

export function cancel() {
  try {
    if (typeof state._resolve === 'function') state._resolve(false);
  } finally {
    state.open = false;
    state.options = null;
    state._resolve = null;
  }
}

export function useConfirmBusState() {
  return state;
}

export default { openConfirm, confirm, cancel, useConfirmBusState };

